import { HoursCell } from "@/components/hours/cell";
import CustomList from "components/list/custom";
import UnderrunJobsReportsFilters from "./filters";
import { ROUTE } from "@/lib/utils";
import { DateCell } from "@/components/date/cell";
import { EmployeeCell } from "components/cell/employee/cell";

export function UnderrunJobsReports() {
  const columns = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ getValue }) => <div>{getValue()}</div>,
    },
    {
      accessorKey: "project.name",
      header: "Project",
      cell: ({ getValue }) => <div>{getValue()}</div>,
    },
    {
      accessorKey: "allocated_hours",
      header: "Allocated",
      cell: HoursCell,
    },
    {
      accessorKey: "spent_hours",
      header: "Spent",
      cell: HoursCell,
    },
    {
      accessorKey: "underrun_hours",
      header: "Underrun",
      cell: HoursCell,
    },
    {
      header: "Start Date",
      accessorKey: "start_date",
      sortable: true,
      cell: DateCell,
    },
    {
      header: "End Date",
      accessorKey: "end_date",
      sortable: true,
      cell: DateCell,
    },
    {
      accessorKey: "coordinator",
      header: "JC",
      cell: EmployeeCell,
    },
    {
      accessorKey: "project.coordinator",
      header: "PC",
      cell: EmployeeCell,
    },
    {
      accessorKey: "account_manager",
      header: "AM",
      cell: EmployeeCell,
    },
    {
      accessorKey: "sales_coordinator",
      header: "SC",
      cell: EmployeeCell,
    },
  ];

  const defaultHref = (item) => ROUTE.JOB(item.id);

  return (
    <div className="flex-1">
      <CustomList
        title="Jobs Underrun Report"
        endPoint="custom-ui/underrun-jobs"
        columns={columns}
        showSearch={true}
        perPage={10}
        href={defaultHref}
        renderFilters={UnderrunJobsReportsFilters}
        storageKey={"Underrun"}
      />
    </div>
  );
}
